<template>
    <div class="modal" ref="modal" role="dialog">
        <div class="modal-dialog" :class="sizeClass">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title accresa-modal-title" v-if="title">{{title}}</h4>
                    <slot name="header"></slot>
                    <button type="button" class="close btn-close" @click.prevent="close">
                        <span aria-hidden="true" class="accresa-close-button">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <slot></slot>
                    </div>
                </div>
                <div class="modal-footer" v-if="hasButtons">
                    <div class="button-box">
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import "bootstrap/js/modal.js";

    export default {
        name: "AcModal",
        props: {title: {type: [String], required: true}, sizeClass: {type: [String], required: false, default: 'modal-lg'}},
        data() {
            return {
                _modalSavedParent: null,
                _modalSavedNextSibling: null,
            };
        },
        computed: {
            hasButtons() {
                return Boolean(this.$slots.buttons)
            }
        },
        mounted() {
            let self = this;
            $(this.$refs.modal).off('hidden.bs.modal').on('hidden.bs.modal', function () {
                self.restoreModalToOriginalParent();
                self.$emit('ac-modal-closed', true);
            })
        },
        beforeDestroy() {
            this.restoreModalToOriginalParent();
        },
        methods: {
            /** Bootstrap appends .modal-backdrop to body (z-index 1040). A modal left inside the app sits under that layer; move to body so z-index 1050 stacks above the backdrop. */
            ensureModalOnBody() {
                const el = this.$refs.modal;
                if (!el || el.parentNode === document.body) {
                    return;
                }
                this._modalSavedParent = el.parentNode;
                this._modalSavedNextSibling = el.nextSibling;
                document.body.appendChild(el);
            },
            restoreModalToOriginalParent() {
                const el = this.$refs.modal;
                if (!el || !this._modalSavedParent) {
                    return;
                }
                const parent = this._modalSavedParent;
                const next = this._modalSavedNextSibling;
                if (next && next.parentNode === parent) {
                    parent.insertBefore(el, next);
                } else {
                    parent.appendChild(el);
                }
                this._modalSavedParent = null;
                this._modalSavedNextSibling = null;
            },
            open() {
                this.ensureModalOnBody();
                $(this.$refs.modal).modal('show');
            },
            close() {
                $(this.$refs.modal).modal('hide');
            }
        }
    }
</script>

<style scoped>
    .accresa-modal-title {
        display: inline;
        color: #343a40;
    }
</style>